/**
 * Veluna Discount Applier - sitewide
 * Ensures any won discount (e.g. from PDP scratch popup) is applied at checkout
 * by routing checkout clicks through /discount/CODE?redirect=/checkout.
 * Also keeps the discount cookie + cart attributes fresh on every page load.
 */
(function () {
  'use strict';

  var STORAGE_KEYS = ['veluna_pdp_mystery_won', 'veluna_email_popup_won', 'veluna_discount_won'];

  function readPrize() {
    for (var i = 0; i < STORAGE_KEYS.length; i++) {
      try {
        var raw = localStorage.getItem(STORAGE_KEYS[i]);
        if (!raw) continue;
        var data = JSON.parse(raw);
        if (data && data.code) return data;
      } catch (_) {}
    }
    return null;
  }

  function refreshCookie(code) {
    try {
      var iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
      iframe.src = '/discount/' + encodeURIComponent(code) + '?redirect=/cart.js';
      iframe.onload = function () { try { iframe.remove(); } catch (_) {} };
      iframe.onerror = function () { try { iframe.remove(); } catch (_) {} };
      document.body.appendChild(iframe);
      setTimeout(function () { try { iframe.remove(); } catch (_) {} }, 4000);
    } catch (_) {}
  }

  function refreshCartAttrs(prize) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'pdp_mystery_code': prize.code,
            'pdp_mystery_percent': String(prize.percent || ''),
            'pdp_mystery_product': prize.product || ''
          }
        })
      }).catch(function () {});
    } catch (_) {}
  }

  function isCheckoutTarget(el) {
    if (!el || !el.closest) return null;
    return el.closest(
      'a[href*="/checkout"], a[href*="/cart/checkout"], ' +
      'button[name="checkout"], button[name="add"][type="submit"][formaction*="/checkout"], ' +
      '[data-checkout-button], [data-action="checkout"], .cart__checkout, .veluna-cart-drawer__checkout'
    );
  }

  function installInterceptor(prize) {
    if (window.__velunaCheckoutInterceptorInstalled) return;
    window.__velunaCheckoutInterceptorInstalled = true;

    document.addEventListener('click', function (e) {
      var current = readPrize();
      if (!current) return;
      var t = isCheckoutTarget(e.target);
      if (!t) return;
      if (t.getAttribute('data-veluna-discount-applied') === '1') return;
      e.preventDefault();
      e.stopPropagation();
      t.setAttribute('data-veluna-discount-applied', '1');
      var target = (t.tagName === 'A' && t.getAttribute('href')) ? t.getAttribute('href') : '/checkout';
      window.location.href = '/discount/' + encodeURIComponent(current.code) + '?redirect=' + encodeURIComponent(target);
    }, true);

    document.addEventListener('submit', function (e) {
      var current = readPrize();
      if (!current) return;
      var form = e.target;
      var action = (form && form.getAttribute && form.getAttribute('action')) || '';
      if (!/\/checkout|\/cart\/checkout/.test(action)) return;
      if (form.getAttribute('data-veluna-discount-applied') === '1') return;
      e.preventDefault();
      form.setAttribute('data-veluna-discount-applied', '1');
      window.location.href = '/discount/' + encodeURIComponent(current.code) + '?redirect=' + encodeURIComponent(action || '/checkout');
    }, true);
  }

  function init() {
    var prize = readPrize();
    if (!prize) return;
    refreshCookie(prize.code);
    refreshCartAttrs(prize);
    installInterceptor(prize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
